/**
 * Data Export API — extraction plate CSV (vue « Données », menu Administratif).
 * @module api/dataExport
 */

import { apiRequest, getAuthHeaders, API_BASE_URL } from './core.js';

function buildQuery(params = {}) {
  const q = new URLSearchParams();
  if (params.from) q.append('from', params.from);
  if (params.to) q.append('to', params.to);
  if (params.siteId) q.append('site_id', params.siteId);
  if (params.columns?.length) q.append('columns', params.columns.join(','));
  return q.toString();
}

/** Nom de fichier choisi par l'utilisateur, débarrassé des caractères refusés par Windows. */
function safeFileName(name) {
  const base = String(name || '').trim().replace(/[\\/:*?"<>|]+/g, '_').replace(/\.csv$/i, '');
  return base ? `${base}.csv` : null;
}

export const dataExportAPI = {
  // Catalogue des jeux exportables — servi par le serveur, rien en dur côté React.
  getCatalog: () => apiRequest('/data-export/catalog'),

  // Aperçu des 5 premières lignes, en JSON.
  preview: async (datasetKey, params = {}) => {
    const query = buildQuery(params);
    const suffix = query ? `&${query}` : '';
    return apiRequest(`/data-export/${datasetKey}.csv?preview=1${suffix}`);
  },

  // Télécharge le CSV (jeton requis : jamais un <a href> nu, la gateway exige le Bearer).
  download: async (datasetKey, params = {}, fileName = null) => {
    const authHeaders = getAuthHeaders();
    const query = buildQuery(params);
    const url = `${API_BASE_URL}/data-export/${datasetKey}.csv${query ? `?${query}` : ''}`;

    const response = await fetch(url, { headers: authHeaders });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `Échec du téléchargement (${response.status})`);
    }

    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition');
    let filename = `fmm_${datasetKey}.csv`;
    if (disposition) {
      const match = disposition.match(/filename="?([^";\n]+)"?/);
      if (match) filename = match[1];
    }
    filename = safeFileName(fileName) || filename;

    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(downloadUrl);

    return { ok: true, filename };
  },
};

export default dataExportAPI;
